export const aside = {
    support: {
        label: "acquérir",
        title: "Support expiré",
        content: "Votre support est expiré. Pour pouvoir créer un nouveau ticket, vous devez <strong>acquérir un pack maintenance</strong>."
    },
	menu: {
		'help-home': {
			title: "Informations",
			label: "Informations"
		},
		'how-it-works': {
			title: "Comment ça marche",
			label: "Comment ça marche"
		}
	}
}
